import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CameraList from 'components/CameraModelSelector/CameraList'
import CameraDetailsContainer from 'components/CameraModelSelector/CameraDetailsContainer'
import { changeCameraModelAction } from 'actions/cameraActions'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'
import { RECENT_DISPLAY_COUNT } from 'helpers/globals'
import { recentModelsSelector, lensModelsSelector } from 'selectors/components'
import sortBy from 'ramda/src/sortBy'
import always from 'ramda/src/always'

const mapStateToProps = state => {
  const { cameras, cameraModels, favoriteModels = [] } = state
  const currentCamera = getCurrentCamera(cameras)
  const model = currentCamera.model

  return {
    cameraModels: lensModelsSelector(state),
    favoriteModels,
    recentModels: recentModelsSelector(state),
    currentModel: model && cameraModels.find(m => m.id === model.id),
    isFixedImager: currentCamera.isFixedImager
  }
}

class LensModelSelector extends React.Component {
  constructor(props) {
    super(props)
    const { currentModel, cameraModels, favoriteModels, recentModels } = this.props

    this.state = {
      selectedCamera: currentModel || null,
      cameras: sortBy(c => recentModels.indexOf(c.id) === -1 ? RECENT_DISPLAY_COUNT + 1 : recentModels.indexOf(c.id))(cameraModels),
      favoriteModels: favoriteModels || [],
      recentModels: recentModels,
      applySingle: false
    }
  }

  updateCameraList = selectedCamera =>
    this.setState({ selectedCamera })

  updateApply = ({ target: { checked } }) =>
    this.setState({ applySingle: !checked })

  makeChangeCameraModelAction = _ => {
    return (model, aov) => this.props.changeCameraModelAction(model, aov, this.state.applySingle)
  }

  componentWillReceiveProps({ favoriteModels, recentModels }) {
    this.setState({
      favoriteModels,
      recentModels
    })
  }

  render() {
    const { updateCameraList, updateApply, state: { selectedCamera, cameras, favoriteModels, recentModels, applySingle },
      props: { isFixedImager, classes } } = this
    const changeCameraModelAction = this.makeChangeCameraModelAction()

    return (
      <div className={classes.lensSelector}>
        <div className={classes.columnWrapper}>
          <CameraList lensSelector { ...{ cameras, selectedCamera, updateCameraList, favoriteModels, recentModels,
            filtersAreInitial: always(true), search: '', selectedManufacturer: null } } />
          <CameraDetailsContainer lensSelector { ...{ selectedCamera, changeCameraModelAction } } />
        </div>
        { !isFixedImager &&
          <div className={classes.checkWrapper}>
            <span>Apply To All Imagers</span>
            <input
              type='checkbox'
              checked={!applySingle}
              onChange={updateApply}
            />
          </div>
        }
      </div>
    )
  }
}
export const LensModelSelectorConfig = { width: '850px', title: 'Change Imager' }
export default connect(mapStateToProps, { changeCameraModelAction })(injectSheet(style)(LensModelSelector))



// WEBPACK FOOTER //
// ./src/components/LensModelSelector/index.js